<template>
    <el-drawer :title="title" size="34%" custom-class="deviceDrawer cloudsceneDrawer" :visible.sync="drawer"
        direction="rtl">
        <div class="drawer-view" v-if="info">
            <div class="title">
                触发条件
                <div class="label" v-if="info.conditionType == '0'">（满足任一条件时）</div>
                <div class="label" v-if="info.conditionType == '1'">（满足全部条件时）</div>
            </div>
            <table class="table-box" border="1" v-if="info.attributeMaps">
                <tr v-for="(item, index) in info.attributeMaps.cloud_scene_trigger" :key="index">
                    <td class="type" style="width: 36%;">{{ backTxt(item.operateType) }}</td>
                    <td class="name">{{ item.propertyName }}</td>
                </tr>
            </table>
            <div class="title">
                执行动作
            </div>
            <table class="table-box" border="1" v-if="info.attributeMaps">
                <tr v-for="(item, index) in info.attributeMaps.cloud_scene_execute" :key="index">
                    <td class="type" style="width: 36%;">{{ item.tabLeftName || "--" }}</td>
                    <td class="name">{{ item.propertyName }} <span class="timeSapn" v-if="item.openTimeName">(开启时长{{
                        item.openTimeName }})</span></td>
                </tr>
            </table>
            <div class="title">
                生效时间
            </div>
            <table class="table-box" border="1" v-if="info.efficientData">
                <tr>
                    <td class="type" style="width: 36%;">
                        <template v-if="info.efficientProperty == '0'">全天</template>
                        <template v-else>
                            {{ info.efficientData.startTime + " - " + info.efficientData.endTime
                            }}<template v-if="showCR()">(次日)</template>
                        </template>
                    </td>
                    <td class="name">
                        <template v-if="info.efficientType != '4'">
                            {{ backTxt2(info.efficientType) }}
                        </template>
                        <template v-else>
                            {{ backWeekLabel(info.efficientData.type) }}
                        </template>
                    </td>
                </tr>
            </table>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: ["triggerTypeList", "timingTypeList", "weekTypeList"],
    data() {
        return {
            drawer: false,
            title: "",
            info: {},
            // triggerTypeList: [
            //     {
            //         "id": "148",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "476",
            //         "modifyName": "yfkj18737634357",
            //         "dictLabel": "传感器",
            //         "dictValue": "0",
            //         "dictDataSort": 1,
            //         "status": 0,
            //         "remark": "例如: 温度上升至30度"
            //     },
            //     {
            //         "id": "149",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "468",
            //         "modifyName": "yfkj18336860927",
            //         "dictLabel": "定时",
            //         "dictValue": "1",
            //         "dictDataSort": 2,
            //         "status": 0,
            //         "remark": "例如: 每天早晨8时"
            //     },
            //     {
            //         "id": "150",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "空间环境变化",
            //         "dictValue": "2",
            //         "dictDataSort": 3,
            //         "status": 0,
            //         "remark": "例如: 室外温度升高到28度"
            //     },
            //     {
            //         "id": "151",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "环境告警",
            //         "dictValue": "3",
            //         "dictDataSort": 4,
            //         "status": 0,
            //         "remark": "例如: 当温度触发告警场景时"
            //     }
            // ],
            // timingTypeList: [
            //     {
            //         "id": "152",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "只执行一次",
            //         "dictValue": "0",
            //         "dictDataSort": 1,
            //         "status": 0,
            //         "remark": ""
            //     },
            //     {
            //         "id": "153",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "每天",
            //         "dictValue": "1",
            //         "dictDataSort": 2,
            //         "status": 0,
            //         "remark": ""
            //     },
            //     {
            //         "id": "154",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "法定工作日",
            //         "dictValue": "2",
            //         "dictDataSort": 3,
            //         "status": 0,
            //         "remark": ""
            //     },
            //     {
            //         "id": "155",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "法定节假日",
            //         "dictValue": "3",
            //         "dictDataSort": 4,
            //         "status": 0,
            //         "remark": ""
            //     },
            //     {
            //         "id": "156",
            //         "createId": "110",
            //         "createName": "18336860927",
            //         "modifyId": "110",
            //         "modifyName": "18336860927",
            //         "dictLabel": "自定义",
            //         "dictValue": "4",
            //         "dictDataSort": 5,
            //         "status": 0,
            //         "remark": ""
            //     }
            // ]
        }
    },
    methods: {
        open(item) {
            this.drawer = true;
            this.$http.getAction(this.$api.cloudscenedetails + "/" + item.id).then((res) => {
                if (res.data) {
                    this.title = res.data.sceneName
                    if (res.data.efficientProperty == "1" || res.data.efficientType == "4") {
                        res.data.efficientData = JSON.parse(res.data.efficientData)
                    }
                    this.info = res.data;
                    if (this.info.attributeMaps.cloud_scene_execute) {
                        this.info.attributeMaps.cloud_scene_execute.forEach((item) => {
                            if (item.propertyList.length) {
                                let deviceSub = item.propertyList[0].deviceSubNum;
                                let deviceId = item.propertyList[0].deviceId
                                let propertyValue = JSON.parse(item.propertyList[0].propertyValue)
                                let propertyName = ""
                                let openTimeName = ""
                                this.$http
                                    .postAction(
                                        this.$api.deviceSub +
                                        "?deviceId=" +
                                        deviceId +
                                        "&subDeviceType=2"
                                    ).then((res) => {
                                        if (res.data) {
                                            let tabLeftName = res.data.deviceName
                                            res.data.subsetList.forEach((ele) => {
                                                if (ele.subDeviceNum == deviceSub) {
                                                    tabLeftName = tabLeftName + " - " + ele.subDeviceName;
                                                    if (propertyValue.attributeKey == "khd") {
                                                        propertyName = propertyValue.attributeName
                                                    } else {
                                                        if (propertyValue.attributeType == "1" || propertyValue.attributeType == "01") {
                                                            propertyName = ele.commandsItemList.filter((a) => {
                                                                return a.commandsItemCode == propertyValue.attributeType
                                                            })[0].commandsItemName
                                                        }else {
                                                            propertyName = ele.commandsItemList.filter((a) => {
                                                                return a.commandsItemCode == propertyValue.attributeType
                                                            })[0].commandsItemName
                                                        }
                                                        if (propertyValue.attributeTime != 0) {
                                                            if (propertyValue.attributeTimeType == '0') {
                                                                let attributeTime = Number(propertyValue.attributeTime);
                                                                openTimeName = attributeTime + "秒"
                                                            } else if (propertyValue.attributeTimeType == '1') {
                                                                let attributeTime = Number(propertyValue.attributeTime) / 60;
                                                                openTimeName = attributeTime + "分钟"
                                                            } else if (propertyValue.attributeTimeType == '2') {
                                                                let attributeTime = Number(propertyValue.attributeTime) / 60 / 60;
                                                                openTimeName = attributeTime + "小时"
                                                            }
                                                        }
                                                    }
                                                }
                                            })
                                            item.tabLeftName = tabLeftName
                                            item.propertyName = propertyName
                                            item.openTimeName = openTimeName
                                            this.$forceUpdate()

                                        }
                                    })
                            }
                        })
                    }
                }
            })

        },

        // 返回文字
        backTxt(operateType) {
            let arr = this.triggerTypeList.filter((item) => {
                return item.dictValue == operateType
            })
            if (!arr.length) {
                return null
            }
            return arr[0].dictLabel
        },
        backTxt2(operateType) {
            let arr = this.timingTypeList.filter((item) => {
                return item.dictValue == operateType
            })
            if (!arr.length) {
                return null
            }
            return arr[0].dictLabel
        },
        // 是否显示次日
        showCR() {
            console.log("执行");
            if (!this.compareTimes(this.info.efficientData.startTime, this.info.efficientData.endTime)) {
                return true
            }
            return false
        },
        compareTimes(time1, time2) {
            if (time1 == "") {
                return true
            }
            if (time2 == "") {
                return true
            }
            // 获取今天的日期
            const now = new Date();

            // 将时间字符串转换为 Date 对象，并假设日期是今天
            const time1Date = new Date(now.toDateString() + ' ' + time1);
            const time2Date = new Date(now.toDateString() + ' ' + time2);

            // 返回比较结果，true 表示 time1 早于 time2
            return time1Date < time2Date;
        },
        // 返回星期几
        backWeekLabel(params) {
            let arr = []
            let indexArr = params.split(",")
            indexArr.sort((a, b) => a - b);
            indexArr.forEach((item) => {
                arr.push(this.weekTypeList[item].dictLabel)
            })
            if (arr.length == 7) {
                return "每天"
            }
            return arr.join(",")
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .cloudsceneDrawer {
    border-radius: 0.225rem 0px 0px 0.225rem;

    .el-drawer__header {
        height: .625rem;
        box-sizing: border-box;
        text-align: left;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #454545;
        padding-top: 0;
        border-bottom: 1px solid #f1f1f1;
        margin-bottom: .325rem;

        span {
            font-size: 0.225rem;
        }
    }

    .el-drawer__close-btn {
        color: #454545;
    }

    .el-drawer__body {
        padding: 0 .4625rem 0.25rem .625rem;
        display: flex;
        flex-direction: column;
        text-align: left;
        flex: 1;
        overflow: auto;

        .drawer-view {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            overflow: auto;

            .title {
                display: flex;
                align-items: center;
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #333333;
                margin-bottom: .35rem;

                &::before {
                    margin-right: .15rem;
                    content: "";
                    width: 3px;
                    height: .1875rem;
                    background: #2DAEA9;
                }

                .label {
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #999999;
                }
            }

            .table-box {
                margin-bottom: .35rem;
                border-color: #F1F1F1;

                tr {
                    td {
                        padding-left: .375rem;
                        height: 46px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 1.5;

                        .timeSapn {
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                        }
                    }
                }
            }
        }
    }


}
</style>